<template>
    <div v-if="cart">
        <section class="detail cf pdg" data-pdgb="80" v-if="cart.cartQuantity !== 0">
            <div class="cart">
                <table class="table">
                    <thead class="header">
                        <tr class="row">
                            <td class="product">{{ localizer.get("Checkout.Common.ProductDescription") }}</td>
                            <td class="qty">{{ localizer.get("Checkout.Common.Quantity") }}</td>
                            <td class="price">{{ localizer.get("Checkout.Common.Price") }}</td>
                            <td class="total">{{ localizer.get("Checkout.Common.Total") }}</td>
                            <td class="remove"></td>
                        </tr>
                    </thead>
                    <tbody class="rows" v-for="cartRow in cart.cartRows">
                        <tr class="row">
                            <td class="product cf">
                                <div class="image" v-if="cartRow.productImageUrl">
                                    <a :href="cartRow.productUrl">
                                        <img :src="cartRow.productImageUrl" width="100" height="100" alt="" loading="lazy" />
                                    </a>
                                </div>
                                <div class="desc">
                                    <a :href="cartRow.productUrl" class="title">{{ cartRow.productTitle }}</a>
                                    <div class="variant"><span class="label">{{ cartRow.variantTitle }}</span>{{ cartRow.variantDescription }}</div>
                                    <div class="cod">{{ localizer.get("Checkout.Common.Cod") }} {{ cartRow.productCode }}</div>
                                </div>
                            </td>
                            <td class="qty cf">
                                <div class="input">
                                    <input name="Quantity" type="number" class="textbox" v-model="cartRow.quantity" />
                                    <div v-if="!isLoadingForm" class="nav">
                                        <button class="button fastic-angle-up" data-type="add" @click="addQuantity(cartRow)"></button>
                                        <button class="button fastic-angle-down" data-type="remove" @click="removeQuantity(cartRow)"></button>
                                    </div>
                                    <div v-else class="nav">
                                        <button class="button fastic-angle-up" data-type="add"></button>
                                        <button class="button fastic-angle-down" data-type="remove"></button>
                                    </div>
                                </div>
                                <button v-if="!isLoadingForm" class="update disable-on-submit" @click="updateQuantity(cartRow)"><span class="icon fastic-refresh"></span><span class="label">{{ localizer.get("Checkout.Common.Update") }}</span></button>
                            </td>
                            <td class="price"><span class="unit">{{ localizer.get("Catalogue.Common.Euro") }}</span>{{ cartRow.unitPrice }}</td>
                            <td class="total"><span class="unit">{{ localizer.get("Catalogue.Common.Euro") }}</span>{{ cartRow.rowPrice }}</td>
                            <td class="remove"><button v-if="!isLoadingForm" class="button disable-on-submit zmdi zmdi-delete" @click="remove(cartRow)"><span class="icon fastic-trash"></span></button></td>
                        </tr>
                    </tbody>
                </table>
                <div class="coupon" v-bind:class="{ active: cart.isCoupon }">
                    <div class="input">
                        <div class="control">
                            <input v-model.lazy="couponCode" id="CouponCode" name="CouponCode" type="text" :aria-label="localizer.get('Checkout.Common.InsertCoupon')" :placeholder="localizer.get('Checkout.Common.InsertCoupon')" @keydown.enter.prevent.stop="setCouponCode()" class="input textbox disable-on-submit" maxlength="50" />
                        </div>
                        <div class="calltoaction" data-color="greyl">
                            <button v-if="!isLoadingForm" class="button disable-on-submit" @click="setCouponCode()">{{ localizer.get("Checkout.Common.Apply") }}</button>
                            <div v-else class="button disable-on-submit">{{ localizer.get("Checkout.Common.Apply") }}</div>
                        </div>
                        <div class="note"><em>{{ localizer.get("Checkout.Common.CouponDisclaimer") }}</em></div>
                    </div>
                    <div class="discount" v-if="cart.isCoupon">
                        <div class="description"><em>{{ cart.couponDescription }}</em></div>
                        <div class="total" v-if="cart.couponDiscount !== 0">
                            <span v-if="cart.couponDiscountMode === 'Amount'">
                                <span class="unit">{{ localizer.get("Catalogue.Common.Euro") }}</span>-{{ formatPrice(cart.couponDiscount) }}
                            </span>
                            <span v-if="cart.couponDiscountMode === 'Percentage'">
                                -{{ cart.couponDiscount }}<span class="unit">%</span>
                            </span>
                        </div>
                        <div class="alert" v-if="cart.couponMinimumCartTotal && cart.couponMinimumGap !== 0">{{ localizer.get("Checkout.Common.CouponGap_Start") }} {{ formatPrice(cart.couponMinimumGap) }} {{ localizer.get("Checkout.Common.CouponGap_End") }}</div>
                    </div>
                </div>
                <div class="footer">
                    <div class="valid-summary">
                        <div v-for="(validationError, index) in validationErrors">{{ validationError.message }}</div>
                    </div>
                    <div class="footer-data">
                        <shippingcosts-preview></shippingcosts-preview>
                        <div class="data">
                            <div class="total">{{ localizer.get("Checkout.Common.TotalIva") }} <span class="unit">{{ localizer.get("Catalogue.Common.Euro") }}</span><span id="CartTotal" class="value">{{ cart.cartTotal }}</span></div>
                            <div class="minimumtotal" v-if="cart.minimumTotalGap">{{ localizer.get("Checkout.Common.MinimumTotal") }} {{ cart.minimumOrderTotal }}</div>
                            <div class="minimumtotalgap" v-if="cart.minimumTotalGap">{{ localizer.get("Checkout.Common.MinimumTotalGap_Start") }} {{ cart.minimumTotalGap }} {{ localizer.get("Checkout.Common.MinimumTotalGap_End") }}</div>
                            <template v-if="cart.shippingMode != 'ExWork'">
                                <div class="shipping" v-if="cart.isFreeShippingCosts">
                                    <div class="shipping-cost" data-free="true">{{ localizer.get("Checkout.Common.FreeShipping") }}</div>
                                </div>
                            </template>
                            <div class="calltoaction" data-size="big">
                                <button v-if="!isLoadingForm" class="button disable-on-submit" @click="checkout()">{{ localizer.get("Checkout.Common.CompleteOrder") }}</button>
                                <span v-else class="button disable-on-submit">{{ localizer.get("Checkout.Common.CompleteOrder") }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section v-else class="detail app-width cf pdg" data-pdgb="80">
            <div class="title">{{ localizer.get("Checkout.Common.Empty_Title") }}</div>
            <div class="subtitle mrg" data-mrgt="20" data-line="false">{{ localizer.get("Checkout.Common.Empty_Abstract") }}</div>
            <div class="mrg" data-mrgt="40">
                <span v-html="localizer.get('Checkout.Common.Empty_Description', routes.Account_Login, localizer.get('Checkout.Common.Empty_Link'))"></span>
            </div>
        </section>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onUpdated, nextTick } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

const store = useStore();

const localizer = Localizer;
const routes = (window as any).App.routes;

const validationErrors = ref<any[]>([]);
const isLoadingForm = ref(false);
const isGAEventSent = ref(false);
const couponCode = ref<string>(null);

const cart = computed(() => {
    let cartData = store.getters["cartStore/cart"];

    couponCode.value = cartData ? cartData.couponCode : null;

    return cartData;
});

function formatPrice(data: string) {
    return Number(data).toFixed(2).replace(".", ",");
}

function addQuantity(cartRow: any) {
    cartRow.quantity = Number(cartRow.quantity);

    if (cartRow.quantity) {
        cartRow.quantity += cartRow.bundleSize;
    } else {
        cartRow.quantity = cartRow.bundleSize;
    }
    if (cartRow.quantity > 1000) {
        cartRow.quantity = 1000;
    }
}

function removeQuantity(cartRow: any) {
    cartRow.quantity = Number(cartRow.quantity);

    if (cartRow.quantity) {
        cartRow.quantity -= cartRow.bundleSize;
    } else {
        cartRow.quantity = cartRow.bundleSize;
    }
    if (cartRow.quantity < 1) {
        cartRow.quantity = cartRow.bundleSize;
    }
}

async function updateQuantity(cartRow: any) {
    FormHelper.removeFocus();

    isLoadingForm.value = true;

    validationErrors.value = [];

    try {
        let response = (await Axios.post(routes.Cart_UpdateQuantity, { cartRowCode: cartRow.cartRowCode, quantity: cartRow.quantity })).data;

        store.commit("cartStore/setCart", response.cartInfo);
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

async function remove(cartRow: any) {
    FormHelper.removeFocus();

    isLoadingForm.value = true;

    validationErrors.value = [];

    try {
        let response = (await Axios.post(routes.Cart_RemoveProduct, { cartRowCode: cartRow.cartRowCode })).data;

        store.commit("cartStore/setCart", response.cartInfo);

        GTagHelper.sendCustomEvent("remove_from_cart", {
            currency: "EUR",
            value: parseFloat(cartRow.UnitPrice.replace(',', '.')) * cartRow.quantity,
            items: [
                {
                    item_id: cartRow.productCode,
                    item_name: cartRow.productTitle,
                    affiliation: "Technical Ceramic",
                    currency: "EUR",
                    item_category: cartRow.categoryName,
                    price: parseFloat(cartRow.unitPrice.replace(',', '.')),
                    quantity: cartRow.quantity
                }
            ]
        });
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

async function setCouponCode() {
    FormHelper.removeFocus();

    isLoadingForm.value = true;

    validationErrors.value = [];

    try {
        const response = (await Axios.post(routes.Cart_SetCouponCode, { couponCode: couponCode.value })).data;

        store.commit("cartStore/setCart", response.cartInfo);
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

async function checkout() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoadingForm.value = true;

    try {
        await Axios.post(routes.Cart_Checkout, { couponCode: couponCode.value });

        window.location = routes.Checkout_Summary;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

onUpdated(() => {
    nextTick(() => {
        if (cart.value && !isGAEventSent.value) {
            var itemList = [];

            for (var cartRow in cart.value.cartRows) {
                itemList.push({
                    item_id: cart.value.cartRows[cartRow].productCode,
                    item_name: cart.value.cartRows[cartRow].productTitle,
                    affiliation: "Technical Ceramic",
                    currency: "EUR",
                    item_category: cart.value.cartRows[cartRow].categoryName,
                    price: parseFloat(cart.value.cartRows[cartRow].unitPrice.replace(',', '.')),
                    quantity: cart.value.cartRows[cartRow].quantity
                });
            }

            GTagHelper.sendCustomEvent("view_cart", {
                currency: "EUR",
                value: parseFloat(cart.value.cartTotalWithCosts.replace(',', '.')),
                items: itemList
            });

            isGAEventSent.value = true;
        }
    });
});
</script>